import { hasInMeta } from 'Utils/router';
import store from 'Store';

function requestAccreditation(to, from, next) {
  const redirectRoute = { name: 'accreditation', query: { ...to.query, redirect: to.path + to.hash } };
  // Redirect to sign in page
  next(redirectRoute);
}

export async function resolveAccreditation(to, from, next) {
  const isRequiresAccreditation = hasInMeta(to, 'requiresAccreditation');
  if (isRequiresAccreditation) {
    await store.getters['profile/profileDataPromise'];
    await store.dispatch('profile/getInvestmentProfileList');
    if (!store.getters['profile/isAccredited'] && !store.getters['profile/isSomeInvestmentProfilePassAccreditation']) {
      requestAccreditation(to, from, next);
      return Promise.reject(new Error('Accreditation Required'));
    }
  }
  return Promise.resolve();
}
